import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';

var style = getPresets(preset, {});
var AccordionBox = /*#__PURE__*/styled("div")({
  name: "AccordionBox",
  class: "a1tkz57u",
  vars: {
    "a1tkz57u-0": [function (_ref) {
      var boxHeight = _ref.boxHeight;
      return boxHeight + "px";
    }]
  }
});
var Cell = /*#__PURE__*/styled("button")({
  name: "Cell",
  class: "cxz4s1p",
  vars: {
    "cxz4s1p-0": [style.background],
    "cxz4s1p-1": [style.color],
    "cxz4s1p-2": [style.borderFocusedColor],
    "cxz4s1p-4": [style.backgroundHover],
    "cxz4s1p-5": [style.backgroundPressed]
  }
});
var Chevron = /*#__PURE__*/styled("div")({
  name: "Chevron",
  class: "c1pllc04",
  vars: {
    "c1pllc04-0": [style.chevronColor],
    "c1pllc04-1": [function (_ref2) {
      var opened = _ref2.opened;
      return opened ? 'rotate(0deg)' : 'rotate(180deg)';
    }]
  }
});
var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bexr0v4",
  vars: {
    "bexr0v4-0": [style.fontFamily]
  }
});

export { AccordionBox, Box, Cell, Chevron };


require('../../styles-linaria/accordion/accordion.styles.css');
